import axios from 'axios';
import moment from 'moment';
import { isEmpty } from 'underscore';
import {
  PayloadShoppingItems,
  PostShoppingItem,
  ShoppingResult,
} from '../../types/shopping';
import { DT0Format } from '../../utils/StaticVariable';
import Api, { axiosInstance } from '../Api';

export default class ShoppingCart {
  endpoint = 'ShoppingCart';

  async GetShoppingCart(
    checkStatus = false,
    withPrice = false
  ): Promise<ShoppingResult> {
    const queryParams = new URLSearchParams();
    queryParams.append('checkExtractionStatus', checkStatus.toString());
    queryParams.append('withPrice', withPrice.toString());

    const data = {
      shoppingItems: {},
    };

    try {
      const r = await axiosInstance.get(
        `/${this.endpoint}/GetShoppingCart_v2?${queryParams.toString()}`
      );
      if (r.data.Error || isEmpty(r.data.Result)) {
        return data as ShoppingResult;
      }
      return r.data.Result;
    } catch (error) {
      return data as ShoppingResult;
    }
  }

  async AddShoppingToCartItem(
    payload: PayloadShoppingItems[]
  ): Promise<{ Result: any; Error: any }> {
    try {
      // This uses the Fetch API instead of axios as change 213ced6e made axios throw undefined error
      const response = await fetch(
        `${axiosInstance.defaults.baseURL}/${this.endpoint}/AddShoppingCartItems`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-XSRF-TOKEN': Api.XSRF_TOKEN,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.status === 200) {
        return { Result: 'OK', Error: null };
      }

      if (!response.ok) {
        const errorData = await response.json();
        return { Result: null, Error: errorData };
      }

      if (response.status !== 200) {
        return response.json();
      }

      return { Result: response.statusText, Error: null };
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  /**
   * @deprecated
   * @param params
   */
  async AddShoppingCartItem_v2(params: PostShoppingItem) {
    const current = moment();
    const connectionString = {
      ...params,
      datasetName: params.datasetId,
      fileFormat: 'csv',
      requestedTime: current.format(DT0Format),
      verticalLevel: null,
      location: params.coords.join(', '),
    };
    const payload = {
      analytics: [],
      extractionResultData: { datasetPrice: params.price },
      connectionString: connectionString,
    };
    try {
      const r: any = await axiosInstance.post(
        `/${this.endpoint}/AddShoppingCartItem_v2`,
        payload
      );

      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  async DeleteShoppingItem(orderId: string) {
    const r = await axiosInstance.delete(
      `/${this.endpoint}/DeleteShoppingItemByOrderIdV2`,
      {
        params: {
          orderId: orderId,
        },
      }
    );
    return r.data;
  }

  // Batch delete shopping items
  async DeleteShoppingItems(orderIds: string[]) {
    const requests = orderIds.map((orderId) =>
      axiosInstance
        .delete(
          `/${this.endpoint}/DeleteShoppingItemByOrderIdV2?datasetId=${orderId}`
        )
        .catch((_err) => null)
    );
    const responses = await axios.all(requests);
    return responses.map((response) => {
      return { ...response?.data };
    });
  }

  async ClearCart() {
    const r = await axiosInstance.delete(
      `/${this.endpoint}/DeleteAllShoppingItems`
    );
    return r.data;
  }
}
